import { Icon } from "@ui-kit/Icon";
import { PopoverInput } from "@ui-kit/Input";

type ProviderPanelSearchProps = {
	query: string;
	onQueryChange: (query: string) => void;
	placeholder: string;
};

export const ProviderPanelSearch = ({ query, onQueryChange, placeholder }: ProviderPanelSearchProps) => (
	<PopoverInput
		onChange={(value) => onQueryChange(value ?? "")}
		placeholder={placeholder}
		startIcon={<Icon className="h-4 w-4 text-muted" icon="search" />}
		value={query}
	/>
);
